import React from 'react';

import { BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';
import { Text, TextType } from 'ui-components/components/text';

import { messages } from '../messages';

/**
 * @param {object} props
 * @param {{ message: string }} [props.error]
 * @param {() => void} props.resetError
 * @returns {React.JSX.Element|null}
 */
export const EnrollmentErrorBanner = ({ error, resetError }) => {
  if (!error) return null;

  return (
    <BannerMessageV2
      content={<Text textType={TextType.Paragraph} value={error?.message || messages.defaultError} />}
      onClose={resetError}
      status={BannerStatus.Error}
    />
  );
};
